import React from 'react';
import PropTypes from 'prop-types';
import ChampDeTexte from '../../UI/ChampDeTexte/ChampDeTexte';
import S from '../ProfilTasks/FormulaireTasks/FormulaireTasks.module.scss';

/**
 * Section d'informations de base de la tâche (nom)
 */
const TaskBasicInfo = ({ nom, erreur, onChange, readOnly = false }) => {
  return (
    <div className={S.section}>
      <h4 className={S.sousTitre}>Informations de la tâche</h4>
      <div className={S.champGroupe}>
        <label className={S.label}>Nom de la tâche *</label>
        <ChampDeTexte
          value={nom}
          onChange={(v) => onChange('nom', v)}
          placeholder="Nom de la tâche"
          erreur={erreur}
          disabled={readOnly}
        />
      </div>
    </div>
  );
};

TaskBasicInfo.propTypes = {
  nom: PropTypes.string.isRequired,
  erreur: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

TaskBasicInfo.defaultProps = {
  erreur: null,
  readOnly: false,
};

export default React.memo(TaskBasicInfo);
